import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import aboutData from "../../data/pages/about.json";
import { HeroComponent } from "../../components/HeroComponent";
import type { AboutPageTemplate } from "../../types/aboutPageTemplate";
import { People } from "./People";

const typedAboutData = aboutData as AboutPageTemplate;

export default function About(): ReactElement {
  return (
    <Stack
      sx={{
        width: "100%",
        maxWidth: "1200px",
        minWidth: 0,
        mx: "auto",
        boxSizing: "border-box",
        flexDirection: "column",
        alignItems: "center",
        pt: "50px",
        px: { xs: 2, sm: 3, md: 5 },
        pb: "48px",
      }}
    >
      <Box sx={{ pb: 4 }}>
        <HeroComponent
          title={typedAboutData.hero.title}
          subtitle={typedAboutData.hero.subtitle}
          align="center"
          titleVariant="h1"
          divider={false}
          description={
            <Stack direction={"column"} maxWidth={650} textAlign={"center"}>
              {typedAboutData.hero.description
                .split("\n\n")
                .map((paragraph, index) => (
                  <Typography
                    key={`about-hero-paragraph-${index.toString()}`}
                    variant="body1"
                    sx={{ mb: index < typedAboutData.hero.description.split("\n\n").length - 1 ? 2 : 0 }}
                  >
                    {paragraph}
                  </Typography>
                ))}
            </Stack>
          }
        />
      </Box>


      <Stack
        sx={{
          width: "100%",
          minWidth: 0,
          gap: 7.5,
          mb: 7.5,
        }}
      >
        <Stack
          sx={{
            flexDirection: "column",
            alignItems: "center",
            gap: "32px",
          }}
        >
          <Typography variant="h3" sx={{ textAlign: "center" }}>
            {typedAboutData.teamSection.title}
          </Typography>
          <Button href={typedAboutData.teamSection.ctaHref} variant="contained">
            {typedAboutData.teamSection.ctaText}
          </Button>
        </Stack>
        <People
          foundersTitle={typedAboutData.foundersSection.title}
          heroesTitle={typedAboutData.heroesSection.title}
        />
      </Stack>
    </Stack>
  );
}
